import React from 'react';
import { type SxProps, type Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
export type AlertBoxMessageProps = {
  children: React.ReactNode;
  enableMarginBottom?: boolean;
  sx?: SxProps<Theme>;
};
export const AlertBoxMessage: React.FC<AlertBoxMessageProps> = ({ children, enableMarginBottom = false, sx = {} }) => {
  return (
    <Typography
      variant="body2"
      sx={{
        lineHeight: '20px',
        fontSize: '14px',
        color: '#475467',
        mt: '4px',
        mb: enableMarginBottom ? '10px' : 0,
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};
